import { useCheckTruncated } from '@shared/hooks/use-truncate'
import { cn } from 'lib/utils'
import { type HTMLAttributes, memo, type ReactNode, useRef } from 'react'
import { Tooltip } from './tooltip'

interface TruncatedTextWithTooltipProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode
  tooltipContent?: ReactNode
  className?: string
  inline?: boolean
}

const TruncatedTextWithTooltipBase = ({
  children,
  tooltipContent,
  className,
  inline = false,
  ...props
}: TruncatedTextWithTooltipProps) => {
  const elementRef = useRef<HTMLDivElement>(null)
  const isTruncated = useCheckTruncated(elementRef)

  const content = (
    <div
      ref={elementRef}
      className={cn('truncate', inline && 'inline-block', className)}
      data-testid="text-truncated"
      {...props}
    >
      {children}
    </div>
  )

  if (!isTruncated) return content

  const tooltipText: ReactNode = tooltipContent ?? (typeof children === 'string' ? children : '')

  return (
    <Tooltip content={tooltipText as string} delayDuration={1000} className="break-words">
      {content}
    </Tooltip>
  )
}

export const TruncatedTextWithTooltip = memo(TruncatedTextWithTooltipBase)
